// // 首页section5
// var viewMoneTab5 = document.querySelector('.collection-tabs-view-more-link5')

// var link5 = viewMoneTab5.querySelectorAll('.collection-tabs__list-link5')
// var button5 = viewMoneTab5.querySelectorAll('.tabs-loading-more-button5')

// button5.forEach((b,i) => {
//     if (i > 0) {
//         b.classList.add('dis_none')
//     }

// })

// link5.forEach((l ,i) => {
//     l.addEventListener('click', () => {
//         // console.log('打印哒哒哒哒哒哒5' + i);
//         button1.forEach((b,index) => {
//             if (index === i) {
//                 b.classList.remove('dis_none');
//             } else {
//                 b.classList.add('dis_none');
//             }
        
//         })
//     })
// })




// 首页section4
// var viewMoneTab5 = document.querySelector('.collection-tabs-view-more-link5')

// var link5 = viewMoneTab5.querySelectorAll('.collection-tabs__list-link5')
// var button5 = viewMoneTab5.querySelectorAll('.tabs-loading-more-button5')

// button5.forEach((b,i) => {
//     if (i > 0) {
//         b.classList.add('dis_none')
//     }

// })

// link5.forEach((l ,i) => {
//     l.addEventListener('click', () => {
//         // console.log('打印哒哒哒哒哒哒4' + i);
//         button1.forEach((b,index) => {
//             if (index === i) {
//                 b.classList.remove('dis_none');
//             } else {
//                 b.classList.add('dis_none');
//             }
        
//         })
//     })
// })


var viewMoneTab5 = document.querySelector('.cccl5')
// viewMoneTab2.addEventListener('click',()=>{
//          console.log('ljdslkfjsdalkfjsdklofjsdaklf');
//     })

var linkk5 = viewMoneTab5.querySelectorAll('.collection-tabs__list-link5')
var buttonn5 = viewMoneTab5.querySelectorAll('.tabs-loading-more-button5')


// viewMoneTab2.addEventListener('click',()=>{
//     console.log('ljdslkfjsdalkfjsdklofjsdaklf');
// })

buttonn5.forEach((b,i) => {
    if (i > 0) {
        b.classList.add('dis_none')
    }

})

linkk5.forEach((l ,i) => {
    l.addEventListener('click', () => {
        // console.log('打印哒哒哒哒哒哒2' + i);
        buttonn5.forEach((b,index) => {
            if (index === i) {
                b.classList.remove('dis_none');
            } else {
                b.classList.add('dis_none');
            }
        
        })
    })
})
